import { createContext, ReactNode, useContext, useState } from "react";

import { DropdownListItem } from "@prequel/shared-components";

export enum Environment {
  STAGING = "staging",
  PROD = "prod",
}

export const dropdownEnvironments: DropdownListItem<Environment>[] = [
  { text: "Production", key: Environment.PROD },
  { text: "Staging", key: Environment.STAGING },
];

type AuthContextType = {
  environment: Environment;
  setEnvironment: (environment: Environment) => void;
};

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [environment, setEnvironment] = useState<Environment>(Environment.PROD);

  return (
    <AuthContext.Provider
      value={{
        environment,
        setEnvironment,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
